import { render, staticRenderFns } from "./PrizeAccount.vue?vue&type=template&id=f16b0886&"
import script from "./PrizeAccount.vue?vue&type=script&lang=js&"
export * from "./PrizeAccount.vue?vue&type=script&lang=js&"
import style0 from "./PrizeAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports